module.exports = __webpack_public_path__ + "media/ingredients-cube-medium.cffaa0d1.mp4";